import React from "react";

function RemoveIcon({
  className,
  style,
}: {
  className?: string;
  style?: object;
}) {
  return (
    <svg className={className} style={style} viewBox="0 0 20.563 20.563">
      <path
        id="Icon_ionic-ios-close-circle"
        d="M13.656,3.375A10.281,10.281,0,1,0,23.938,13.656,10.28,10.28,0,0,0,13.656,3.375Zm2.6,14-2.6-2.6-2.6,2.6a.79.79,0,1,1-1.117-1.117l2.6-2.6-2.6-2.6a.79.79,0,0,1,1.117-1.117l2.6,2.6,2.6-2.6a.79.79,0,1,1,1.117,1.117l-2.6,2.6,2.6,2.6a.794.794,0,0,1,0,1.117A.785.785,0,0,1,16.261,17.378Z"
        transform="translate(-3.375 -3.375)"
      />
    </svg>
  );
}

export { RemoveIcon };
